import { http } from '../http';

export const requestCsv = async (): Promise<any> => {
  const response = await http({
    url: '/api/v1/lenders/client-extract-export',
    method: 'POST',
  });

  return response;
};
